import React, { ReactElement } from 'react';
import { FormInstance } from 'antd/lib/form';

import { CLIENT_STATUS } from '../../../types/Client';

import { useClientFormContext } from '../ClientFormContext';
import ClientFormHeader from '../../../components/Client/ClientFormHeader';
import FleetsFormSection from '../../../components/Feature/FleetsFormSection';
import DriversEtaFormSection from '../../../components/Feature/DriversEtaFormSection';
import ClientForm from '../ClientForm';
import { submitDriversEtaConfigFactory, submitFleetsConfigFactory } from '../utils/submit';

const ClientFleetsForm: React.FC = (): React.ReactElement => {
    const { client, data, formConfig, resetFormFlag, setData } = useClientFormContext();

    const submitForm = async (form: FormInstance): Promise<void> => {
        if (!client) return;

        Promise.allSettled([
            submitFleetsConfigFactory(client.id, data.fleets)(form),
            submitDriversEtaConfigFactory(client.id, data.driversEta)(form),
        ]).then(([fleetsRes, driversEtaRes]) => {
            const newData = { ...data };
            if (fleetsRes.status === 'fulfilled') newData.fleets = fleetsRes.value;
            if (driversEtaRes.status === 'fulfilled') newData.driversEta = driversEtaRes.value;
            setData(newData);
        });
    };

    return (
        <>
            <div className="shadow-sm pb-4">
                <ClientFormHeader />
                <div className="px-4">
                    <ClientForm name="fleets" submitForm={submitForm}>
                        {({ form }): ReactElement => (
                            <>
                                <FleetsFormSection
                                    formInstance={form}
                                    isDetailMode={formConfig.isDetailMode}
                                    resetFormFlag={resetFormFlag}
                                    enableControls={client?.status !== CLIENT_STATUS.DELETED}
                                    fleetsConfig={data.fleets}
                                />
                                <DriversEtaFormSection
                                    formInstance={form}
                                    isDetailMode={formConfig.isDetailMode}
                                    resetFormFlag={resetFormFlag}
                                    driversEtaConfig={data.driversEta}
                                />
                            </>
                        )}
                    </ClientForm>
                </div>
            </div>
        </>
    );
};

export default ClientFleetsForm;
